import slugify from 'slugify';

const field_formats = {
  slugify: (v: string): string => {
    v = v.replace(/ /g, '-');
    v = v.replace(/_{2,}/g, '_');
    v = v.replace(/_-/g, '_');
    v = v.replace(/-_/g, '-');

    return slugify(v, {
      replacement: '-',
      lower: false,
      remove: /[^\w\s-]+/g,
      trim: false,
    });
  },
  viewName: (v: string): string => {
    return v.replace(/[^\w\s\-_()]+/g, '');
  },
  slugifyWithWildcard: (v: string): string => {
    const is_negated = v.startsWith('!');
    const pattern = is_negated ? v.slice(1) : v;
    // Slugify the text between wildcards so `*` is kept anywhere in the pattern,
    // then collapse repeated wildcards, which match the same names as one.
    const slug = pattern
      .replace(/ /g, '-')
      .split('*')
      .map((segment) => slugify(segment, { lower: true, strict: true, trim: false }))
      .join('*')
      .replace(/\*{2,}/g, '*');
    return is_negated ? `!${slug}` : slug;
  },
};

export default field_formats;
